import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import orderBy from 'lodash-es/orderBy';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';

import PresentationsSvc from '../../../../../services/dbServices/PresentationsSvc';
import { GOLD } from '../../../../../data/permissions';
import withComponentName from '../../../../../decorators/withComponentName';
import { getESGTypeImg } from '../../../../../helpers/presentationsHelpers';

import CustomYearBar from './CustomYearBar';
import Tooltip from '../../StoryCardLists/StoryCardRow/Tooltip';
import Preloader from '../../../../Preloader';
import CompanyTags from './CompanyTags';
import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class AllTypesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: '',
      isLoading: true,
      periodGroupStory: [],
      otherMainData: [],
      selectedCompany: null,
    };

    autoBind(this);
    this.typeReportRef = createRef();
  }

  componentDidMount() {
    const {
      firstSelectedYear, isWatchlists, companyLists, hasOthersData,
    } = this.props;
    if (firstSelectedYear) {
      this.setState({
        selectedYear: firstSelectedYear,
        selectedCompany: isWatchlists ? (companyLists || [])[0] : null,
      }, () => {
        this.generateData();
      });
    }
    const { type } = this.props;
    if (type.toLowerCase().includes('annual')) {
      this.generateAnnualReport();
    }
    if (hasOthersData) {
      this.generateOtherMainData();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      firstSelectedYear, isWatchlists, companyLists, isTypeLoading, hasOthersData,
    } = this.props;
    if (firstSelectedYear !== prevProps.firstSelectedYear) {
      const { selectedCompany } = this.state;
      let newSelectedCompany = selectedCompany;
      if (isWatchlists) {
        const foundCompany = companyLists.find((f) => f.id === (selectedCompany || {}).id);
        if (!foundCompany) {
          newSelectedCompany = (companyLists || [])[0] || null;
        }
      }
      this.setState({
        selectedYear: firstSelectedYear,
        selectedCompany: newSelectedCompany,
      }, () => {
        this.generateData();
      });
    }
    if (isWatchlists && !isTypeLoading && isTypeLoading !== prevProps.isTypeLoading) {
      const { selectedCompany } = this.state;
      let newSelectedCompany = selectedCompany;
      if (isWatchlists) {
        const foundCompany = companyLists.find((f) => f.id === (selectedCompany || {}).id);
        if (!foundCompany) {
          newSelectedCompany = (companyLists || [])[0] || null;
        }
      }
      this.setState({
        selectedCompany: newSelectedCompany,
      }, () => {
        this.generateData();
        const { type } = this.props;
        if (type.toLowerCase().includes('annual')) {
          this.generateAnnualReport();
        }
        if (hasOthersData) {
          this.generateOtherMainData();
        }
      });
    }
  }

  callAPI(params, defaultValue = {}) {
    const { isEsg } = this.props;

    if (isEsg) {
      return PresentationsSvc.getPresentationsEsgData(params)
        .then(({ data }) => data || defaultValue)
        .catch(() => defaultValue);
    }
    return PresentationsSvc.getPresentationsData(params)
      .then(({ data }) => data || defaultValue)
      .catch(() => defaultValue);
  }

  async generateAnnualReport() {
    this.setState({
      isLoading: true,
    });
    const {
      type, identifierProps, isPremium, isWatchlists, companyLists,
    } = this.props;
    const params = {
      type,
      per: 3,
      group: 'year',
      identifiers: identifierProps,
      is_premium: isPremium,
    };

    if (isWatchlists) {
      const { selectedCompany } = this.state;
      const { identifiers } = selectedCompany || (companyLists || [])[0] || {};
      params.identifiers = identifiers;
    }
    const data = await this.callAPI(params);

    const groupStory = [];
    for (let i = 0; i < Object.keys(data).length; i += 1) {
      const currentPeriod = Object.keys(data)[i];
      const currentData = data[currentPeriod];
      if (currentData) {
        groupStory.push({
          periodTitle: currentPeriod,
          storyList: currentData,
        });
      }
    }

    const newData = orderBy(groupStory, 'periodTitle', 'desc').slice(0, 5);
    this.setState({
      isLoading: false,
      periodGroupStory: newData,
    }, () => {
      this.handleResizeMasonryItem();
    });
  }

  async generateData() {
    const {
      type, identifierProps, isPremium, isWatchlists, isEsg,
    } = this.props;
    if (type.toLowerCase().includes('annual')) return;

    this.setState({
      isLoading: true,
    });
    const { selectedYear, selectedCompany } = this.state;
    if (!selectedYear) {
      return this.setState({
        isLoading: false,
        periodGroupStory: [],
      }, () => {
        this.handleResizeMasonryItem();
      });
    }

    const params = {
      type,
      per: 3,
      group: 'period',
      identifiers: identifierProps,
      is_premium: isPremium,
    };

    if (isEsg) {
      params['year-from'] = selectedYear;
      params['year-to'] = selectedYear;
    } else {
      params.year = selectedYear;
    }

    if (isWatchlists) {
      const { identifiers } = selectedCompany || {};
      params.identifiers = identifiers;
    }

    const data = await this.callAPI(params);
    const periodArr = Object.keys(data).filter((f) => f);
    periodArr.push('');
    const groupStory = [];
    for (let i = 0; i < periodArr.length; i += 1) {
      const currentPeriod = periodArr[i];
      const currentData = data[currentPeriod];
      if (currentData) {
        groupStory.push({
          periodTitle: currentPeriod,
          storyList: currentData,
        });
      }
    }
    this.setState({
      isLoading: false,
      periodGroupStory: groupStory,
    }, () => {
      this.handleResizeMasonryItem();
    });
  }

  async generateOtherMainData() {
    const {
      type, identifierProps, isPremium, isWatchlists, companyLists,
    } = this.props;
    const params = {
      type,
      per: 3,
      identifiers: identifierProps,
      year: 'null',
      is_premium: isPremium,
    };

    if (isWatchlists) {
      const { selectedCompany } = this.state;
      const { identifiers } = selectedCompany || (companyLists || [])[0] || {};
      params.identifiers = identifiers;
    }

    const data = await this.callAPI(params, []);
    this.setState({
      otherMainData: data,
    }, () => {
      this.handleResizeMasonryItem();
    });
  }

  handleYearChange(year) {
    this.setState({
      selectedYear: year,
    }, () => {
      this.generateData();
    });
  }

  handleCompanyChange(company) {
    this.setState({
      selectedCompany: company,
    }, () => {
      this.generateData();
      const { type, hasOthersData } = this.props;
      if (type.toLowerCase().includes('annual')) {
        this.generateAnnualReport();
      }
      if (hasOthersData) {
        this.generateOtherMainData();
      }
    });
  }

  handleResizeMasonryItem() {
    const { resizeMasonryItem } = this.props;
    resizeMasonryItem(this.typeReportRef.current);
  }

  render() {
    const {
      selectedYear, isLoading, periodGroupStory, otherMainData, selectedCompany,
    } = this.state;
    const {
      type, title, yearsOptions, isPremium,
      isWatchlists, companyLists, isSingleTopic, hasNoYearFilters, isEsg, hasOthersData, isIR,
    } = this.props;

    const isNoDataFound = !periodGroupStory.length && !isLoading;
    const isAnnual = type.toLowerCase().includes('annual');
    const isOthers = hasOthersData;
    const typesStoryBoxClass = cx('types_story_box', { hidden: hasNoYearFilters, esg: isEsg, ir: isIR });
    const imgUrl = getESGTypeImg(type);

    return (
      <div
        className={cx('types_common_container', {
          watchlists: isWatchlists, no_years: hasNoYearFilters, esg: isEsg, ir: isIR,
        })}
        ref={this.typeReportRef}
      >
        {imgUrl && isEsg && (
          <div className={Styles.type_img_holder}>
            <img
              src={imgUrl}
              alt=""
              onLoad={this.handleResizeMasonryItem}
            />
          </div>
        )}
        <div className={cx('header_title', { annual: isAnnual })}>
          {title}
        </div>

        {isWatchlists && !isSingleTopic && type.toLowerCase() === 'others' && (
          <CompanyTags
            selectedCompany={selectedCompany}
            companyLists={companyLists}
            handleCompanyChange={this.handleCompanyChange}
            isIR={isIR}
          />
        )}

        {isOthers && (
          <div className={Styles.others_types_story}>
            {otherMainData.map((data) => (
              <StoryRowTitle
                key={data.id}
                data={data}
                isPremium={isPremium}
                isEsg={isEsg}
                isIR={isIR}
              />
            ))}
          </div>
        )}

        {!isAnnual && !hasNoYearFilters && (
          <div className={Styles.scroll_bar_holder}>
            <CustomYearBar
              isEsg={isEsg}
              isIR={isIR}
              selectedYear={selectedYear}
              data={yearsOptions}
              onClick={this.handleYearChange}
            />
          </div>
        )}
        {isWatchlists && !isSingleTopic && type.toLowerCase() !== 'others' && (
          <CompanyTags
            selectedCompany={selectedCompany}
            companyLists={companyLists}
            handleCompanyChange={this.handleCompanyChange}
            isIR={isIR}
          />
        )}

        <div className={typesStoryBoxClass}>
          <Preloader loading={isLoading} top="-15px" />
          {isNoDataFound && (
            <div>
              No data found
            </div>
          )}
          {periodGroupStory.map((data) => (
            <StoryRow
              key={data.periodTitle}
              periodTitle={data.periodTitle}
              data={data}
              isPremium={isPremium}
              isEsg={isEsg}
              isIR={isIR}
            />
          ))}
        </div>
      </div>
    );
  }
}

const StoryRow = ({
  periodTitle, data, isPremium, isEsg, isIR,
}) => (
  <div className={cx('types_story_row', { others: periodTitle === 'Others' })}>
    <div className={Styles.types_story_period}>
      {periodTitle}
    </div>
    {data.storyList.map((story) => (
      <StoryRowTitle
        key={story.id}
        isPremium={isPremium}
        data={story}
        isEsg={isEsg}
        isIR={isIR}
      />
    ))}
  </div>
);

const StoryRowTitle = ({
  isPremium, data, isEsg, isIR,
}) => {
  const { link, title, extension } = data;

  const fetchIcon = (linkExt, ext) => {
    const extension = ext || linkExt;
    switch (extension) {
      case 'pdf':
        return 'pdf';
      case 'xls':
        return 'xls';
      case 'xlsx':
        return 'xls';
      case 'doc':
        return 'doc';
      case 'rft':
        return 'rft';
      case 'zip':
        return 'zip';
      default:
        return null;
    }
  };

  const getLinkExtension = (link) => link && link.split('/').reverse()[0].split('.').reverse()[0];
  return (
    <div className={Styles.types_story_title}>
      {isPremium ? (
        <a
          className={Styles.row_header_content}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={Styles.title_container}>
            {title}
            {((['pdf', 'xls', 'xlsx', 'rft', 'zip', 'doc'].includes(extension) || ['pdf', 'xls', 'xlsx', 'rft', 'zip', 'doc'].includes(getLinkExtension(link)))) && <span className={Styles[fetchIcon(getLinkExtension(link), extension)]} />}
          </div>
        </a>
      ) : (
        <Tooltip tootipText={title} hasBigScreenDesign={isEsg || isIR}>
          <Link to="/pricing" className={Styles.plan_url}>Upgrade to Gold plan</Link>
          &nbsp;to use this feature
        </Tooltip>
      )}
    </div>
  );
};

const mapStateToProps = ({ common, subscriptions }) => {
  const { permissions } = subscriptions;
  const { access_levels: accessLevels } = permissions;

  return {
    width: common.width,
    isPremium: accessLevels.includes(GOLD),
  };
};

export default withComponentName(
  connect(mapStateToProps, null)(AllTypesReport),
);
